/**
 * useAuth Hook - Convenient way to use AuthContext
 */

import { useContext } from 'react';
import { AuthContext } from '../services/AuthContext';

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};
